import { Main } from './components/containers';

export const Mappings = () => {
  return <Main />;
};
